import {
  getDatabase,
  onValue,
  orderByKey,
  query,
  ref,
} from "firebase/database";
import { useEffect, useState } from "react";

export default function useUsersList(page) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(true);
  const [users, setUsers] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  useEffect(() => {
    fetchUsers();
  }, [page]);

  async function fetchUsers() {
    //databse related works
    const db = getDatabase();
    const usersRef = ref(db, "Users");
    // const usersQuery = query(
    //   usersRef,
    //   orderByKey(),
    //   startAt("" + page),
    //   limitToFirst(8)
    // );
    const usersQuery = query(usersRef, orderByKey());

    try {
      setError(false);
      setLoading(true);
      //request firebase database;

      onValue(usersQuery, (snapshot) => {
        setLoading(false);
        if (snapshot.exists()) {
          setUsers((prevUsers) => {
            return [...Object.values(snapshot.val())];
          });
        }
      });

      // const snapshot = await get(usersQuery);
      // setLoading(false);
      // if (snapshot.exists()) {
      //   setUsers((prevUsers) => {
      //     return [...Object.values(snapshot.val())];
      //   });
      // } else {
      //   //no data found.
      //   setHasMore(false);
      // }
    } catch (err) {
      setLoading(false);
      setError(true);
    }
  }
  return { loading, error, users, hasMore, setUsers, fetchUsers };
}
